// Loading.js
import React, { useEffect, useState } from 'react';
import { LeftSide } from '../../components/LeftSide/LeftSide';
import { Navi } from '../../components/Navi/Navi';
import { RightBar } from '../../components/RightBar/RightBar';
import './DashBoard.css';
import {
    Users, // 전체 회원 수
    UserPlus, // 신규 가입자
    AlertTriangle, // 만료 임박 회원
    Activity, // 오늘 접속자
    BarChart3, // 새 섹션용 아이콘
} from 'lucide-react';
import api from '../../utils/api'; // ✅ axios 인스턴스 (이미 있으시면 그대로 사용)

const DashBoard = ({ title = 'Dashboard' }) => {
    const [historyStats, setHistoryStats] = useState([]); // ✅ 검색 기록 통계 상태
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const allTypes = Object.keys(typeMap); // ✅ typemap의 key 배열 추출

                const res = await api.get('/dashboard/history', {
                    params: {
                        allTypes: JSON.stringify(allTypes), // ✅ 서버에 전달
                        period: 'today', // 기본은 오늘
                    },
                });

                if (res.data.success) {
                    console.log('✅ [대시보드] 검색 기록 통계:', res.data.data);
                    setHistoryStats(res.data.data);
                } else {
                    console.warn('⚠️ [대시보드] 서버 응답 실패:', res.data.message);
                }
            } catch (err) {
                console.error('❌ [대시보드] 검색 기록 통계 불러오기 실패:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchHistory();
    }, []);

    const topStats = [
        {
            title: '전체 회원 수',
            today: 1842,
            yesterday: 1821,
            diff: '+21명',
            isUp: true,
            icon: <Users size={22} className="dash-icon" />,
        },
        {
            title: '신규 가입자',
            today: 124,
            yesterday: 115,
            diff: '+8%',
            isUp: true,
            unit: '명',
            icon: <UserPlus size={22} className="dash-icon" />,
        },
        {
            title: '만료 임박 회원',
            subValues: [
                { label: '금일 만료', value: 5 },
                { label: '3일 이내 만료', value: 19 },
            ],
            icon: <AlertTriangle size={22} className="dash-icon" />,
        },
        {
            title: '오늘 접속자',
            today: 312,
            yesterday: 298,
            diff: '+4.7%',
            isUp: true,
            unit: '명',
            icon: <Activity size={22} className="dash-icon" />,
        },
    ];

    // const serviceStats = [
    //     { title: '한도 사용량', value: '72%', diff: '-2%', isUp: false },
    //     { title: '키워드 추출 순위 1', value: '156회', diff: '+12회', isUp: true },
    //     { title: '키워드 추출 순위 2', value: '103회', diff: '-5회', isUp: false },
    //     { title: '키워드 통합검색 순위', value: '88회', diff: '+9회', isUp: true },
    //     { title: 'MID 조회', value: '69회', diff: '+4회', isUp: true },
    //     { title: '네이버 순위조회', value: '201회', diff: '-8회', isUp: false },
    //     { title: '네이버 매출분석', value: '142회', diff: '+11회', isUp: true },
    // ];

    const typeMap = {
        keywordver1: '키워드 추출 순위 Ver1',
        keywordver2: '키워드 추출 순위 Ver2',
        naverIntegratedRank: '네이버 통합검색 순위',
        findMid: 'MID 조회',
        findProductByMid: '상품정보 조회',
        naversales: '네이버 매출분석 조회',
        sales: '네이버 매출분석 조회',
        index: '네이버 지수 조회',
        findNaverRank: '네이버 순위 조회',
        findNaverRankTracking: '네이버 순위 추적',
        keywordRankVolumeCheck: '통합작업키워드추출',
        countText: '글자수 세기>검색량 조회',
        integratedSearch: '통합 키워드 검색',
        productAnalysis: 'N상품종합분석',
        rankHistoryWatch: '과거 순위 조회',
    };

    return (
        <>
            <div id="wrapper">
                <Navi title={title} />
                <LeftSide />

                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid py-3">
                            {/* ── 상단 주요 통계 ─────────────────────────────── */}
                            <div className="row g-3 mb-4">
                                {topStats.map((item, i) => (
                                    <div className="col-md-6 col-xl-3" key={i}>
                                        <div className="dash-card shadow-sm">
                                            <div className="dash-header-row">
                                                <div className="dash-header">
                                                    {item.icon}
                                                    <span>{item.title}</span>
                                                </div>
                                            </div>

                                            {/* 일반 수치 카드 */}
                                            {item.today && (
                                                <>
                                                    <div className="dash-value">
                                                        {item.today.toLocaleString()}
                                                        {item.unit || '명'}
                                                    </div>
                                                    <div className="dash-footer">
                                                        <span className="dash-yesterday">
                                                            어제: {item.yesterday.toLocaleString()}
                                                            {item.unit || '명'}
                                                        </span>
                                                        <span
                                                            className={
                                                                'dash-diff ' +
                                                                (item.isUp
                                                                    ? 'text-up'
                                                                    : 'text-down')
                                                            }
                                                        >
                                                            {item.isUp ? '▲' : '▼'} {item.diff}
                                                        </span>
                                                    </div>
                                                </>
                                            )}

                                            {/* 만료 임박 카드 */}
                                            {item.subValues && (
                                                <div className="dash-dual-column">
                                                    {item.subValues.map((s, j) => (
                                                        <div key={j} className="dual-line">
                                                            <span className="dual-label">
                                                                {s.label}
                                                            </span>
                                                            <span className="dual-value">
                                                                {s.value}명
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* ── 서비스 이용 현황 ───────────────────────────── */}
                            <div className="dash-section">
                                <div className="dash-section-title">서비스 이용 현황</div>

                                {loading ? (
                                    <div className="text-center py-3">불러오는 중...</div>
                                ) : (
                                    <div className="row g-3">
                                        {Object.keys(typeMap)
                                            .map(key =>
                                                historyStats.find(item => item.type === key)
                                            )
                                            .filter(Boolean) // 없는 타입 제외
                                            .map((item, i) => {
                                                const title = typeMap[item.type];
                                                const value = `${item.current.toLocaleString()}회`;
                                                const diffText =
                                                    item.diff === 0
                                                        ? '변동 없음'
                                                        : `${item.diff > 0 ? '+' : ''}${item.diff.toLocaleString()}회`;

                                                return (
                                                    <div
                                                        className="col-md-6 col-lg-4 col-xl-3"
                                                        key={i}
                                                    >
                                                        <div className="dash-service-card">
                                                            <div className="service-title">
                                                                {title}
                                                            </div>
                                                            <div className="service-body">
                                                                <span className="service-value">
                                                                    {value}
                                                                </span>
                                                                <span
                                                                    className={`service-diff ${
                                                                        item.isUp
                                                                            ? 'text-up'
                                                                            : 'text-down'
                                                                    }`}
                                                                >
                                                                    {item.isUp ? '▲' : '▼'}{' '}
                                                                    {diffText}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                )}
                            </div>

                            {/* ── 🔹 검색 기록 통계 섹션 ───────────────────────────── */}
                            <div className="dash-section mt-4">
                                <div className="dash-section-title">
                                    <BarChart3 size={20} className="me-2" />
                                    검색 기록 통계
                                </div>

                                {loading ? (
                                    <div className="text-center py-3">불러오는 중...</div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm align-middle">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>유형</th>
                                                    <th>오늘</th>
                                                    <th>어제</th>
                                                    <th>최근 7일</th>
                                                    <th>지난주</th>
                                                    <th>이번달</th>
                                                    <th>지난달</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historyStats.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">
                                                            데이터가 없습니다.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    historyStats.map((row, idx) => (
                                                        <tr key={idx}>
                                                            <td>{row.type}</td>
                                                            <td>{row.today}</td>
                                                            <td>{row.yesterday}</td>
                                                            <td>{row.last_7_days}</td>
                                                            <td>{row.last_week}</td>
                                                            <td>{row.this_month}</td>
                                                            <td>{row.last_month}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            {/* ── 최근 추세 ──────────────────────────────────── */}
                            <div className="dash-section mt-4">
                                <div className="dash-section-title">최근 추세</div>
                                <div className="dash-placeholder">
                                    (차트 / 테이블 / 그래프 자리)
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <RightBar />
            <div className="rightbar-overlay"></div>
        </>
    );
};

export { DashBoard };
